import React from 'react';
import {
  Root,
  Value,
  Icon,
  Portal,
  Group,
  ItemText,
} from '@radix-ui/react-select';

import {
  ChevronDownIcon,
  Container,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectViewport,
} from './Picker.styles';

interface Props {
  pickedValue: string;
  values: string[];
  onValuePicked: (value: string) => void;
}

const Picker = ({ pickedValue, values, onValuePicked }: Props) => {
  return (
    <Container>
      <Root onValueChange={onValuePicked} value={pickedValue}>
        <SelectTrigger className="SelectTrigger">
          <Value placeholder={pickedValue}>{pickedValue}</Value>
          <Icon>
            <ChevronDownIcon />
          </Icon>
        </SelectTrigger>
        <Portal>
          <SelectContent position="popper">
            <SelectViewport>
              <Group>
                {values.map((val) => (
                  <SelectItem key={val} value={val}>
                    <ItemText>{val}</ItemText>
                  </SelectItem>
                ))}
              </Group>
            </SelectViewport>
          </SelectContent>
        </Portal>
      </Root>
    </Container>
  );
};

export default Picker;
